//document ready
$(function() {
  /*============================================================================
    Start of cart-related functionality
  ==============================================================================*/
  $('body').on('click', '.js-change-quantity', function() {
    var $this = $(this),
        $input = $(this).siblings('input'),
        val = parseInt($input.val()),
        valMax = 100000000000000000000000000000,
        valMin = $input.attr('min') || 0;

    if ($input.attr('max') != null){
      valMax = $input.attr('max');
    }

    if(isNaN(val) || val < valMin) {
      $input.val(valMin);
      return false;
    } else if (val > valMax) {
      $input.val(valMax);
      return false;
    }

    if($this.data('func') == 'plus') {
      if(val < valMax) $input.val(val + 1);
    } else {
      if(val > valMin) $input.val(val - 1);
      if($this.parents(".cart_item").length) {
        if (val - 1 == 0) {
          $this.closest('.cart_item').addClass('animated fadeOutUp')
        }
      }
    }
    $input.trigger('change');

  });

  function ajaxSubmitCart(cart) {
    $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success: function (data) {
        refreshCart(data);
      }
    });
  }

  function ajaxUpdateCart(lineID, quantity, parent) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: { quantity: quantity, line: lineID },
      success: function (data) {
        refreshCart(data);

        var lineIDIndex = lineID - 1;

        //check to see if there are correct amount of products in array
        if (typeof data.items[lineIDIndex] === "undefined"){
          var updated_quantity = 0;
        } else {
          var updated_quantity = data.items[lineIDIndex].quantity;
        }

        if(quantity > 0 && quantity != updated_quantity) {
          if (updated_quantity == 1) {
            items_left_text = "products available in stock";
          } else {
            items_left_text = "products available in stock";
          }

          $('.warning--quantity').remove();

          var warning = '<p class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</p>';
          parent.find("input[data-line-id='" + lineID + "']").parent().after(warning);
          parent.find("input[data-line-id='" + lineID + "']").val(updated_quantity);
        } else if (parent.is('#cart_form')) {
          $("#cart_form").submit();
        }
      }
    });
  }

function refreshCart(cart) {
  $(".cart_count").empty();
  var $cartBtn = $(".cart_count");
  var value = $cartBtn.text() || '0';
  var cart_items_html = "";
  var cart_discounts_html = "";
  var cart_action_html = "";
  var cart_savings_html = "";
  var $cart = $(".cart_content form");
  var discounted_price_total = 0;
  var total_savings = 0;
  var totalSaving = 0; // adding counter variables for total cart savings
  var saving = 0;
  var productHasSale = false;
  var productCompareAtPrice = 0;
  var productFinalPrice = 0;
  var shipping_savings = 3000;

  // NEW FLAG to detect presence of “subscription-bulk-3kg” items
  var hasWholesale = false;

  // Update cart count in the cart icon
  $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));

  if (cart.item_count == 0) {
    $('.js-empty-cart__message').removeClass('hidden');
    $('.js-cart_content__form').addClass('hidden');
    $('.annoucement-message').addClass('hidden');
    $('#CartCount').addClass('hide');
  } else {
    $('.js-empty-cart__message').addClass('hidden');
    $('.js-cart_content__form').removeClass('hidden');
    $('.annoucement-message').removeClass('hidden');
    $('#CartCount').removeClass('hide');

    // Build list of cart items
    $.each(cart.items, function(index, item) { 
      var itemDiscounts = item.discounts;
      var discountMessage = "";

      for (i = 0; i < itemDiscounts.length; i++) {
        var amount = Shopify.formatMoney(itemDiscounts[i].amount, $('body').data('money-format'));
        var title = itemDiscounts[i].title;
        discountMessage = '<p class="notification-discount meta"><strong>Discount:</strong> ' + title + ' (-<span class="money"> ' + amount + '</span>)</p>';
      }

      var line_id = index + 1;

      cart_items_html += '<li class="mini-cart__item clearfix">';

      if (item.image) {
        cart_items_html += '<div class="cart_image">' +
          '<img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
        '</div>';
      }

      cart_items_html += '<div class="item_cart_title"><div class="cart_item__title"><a href="' + item.url +'"><div class="item_title"><div class="item_titles">' + item.title+'</div>';

      if(item.properties) {
        $.each(item.properties, function(title, value) {
          if (value) {
            cart_items_html += '<div class="line-item">' + title +': ' + value + '</div>';
          }
        });
      }

      for (i=0; i < item.options_with_values.length; i++) {
        cart_items_html += '<div class="option-selected">' + item.options_with_values[i].name +': ' + item.options_with_values[i].value + '</div>'; 
      }

      cart_items_html += '</div></a></div>';

      cart_items_html += '<div class="left product-quantity-box">' +
        '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><img src="//goodflour.co/cdn/shop/t/72/assets/icon-minus.png?v=26673911418252786511752093799"></span>' +
          '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'" data-line-id="' + line_id +'" />' +
          '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><img src="//goodflour.co/cdn/shop/t/72/assets/icon-plus.png?v=136739665506228685841752093800"></span>' +
        '</div>'; 

      cart_items_html += '<strong class="right price">';

      // NOTE: The product call – checking each item
      $.ajax({
        dataType: 'json',
        async: false, // blocking call (already in your code)
        cache: false,
        url: "/products/" + item.handle + ".js",
        success(data) {
          // 1) Check if this product is part of the special collection by tag
          //    If your products in the “subscription-bulk-3kg” collection have a tag named exactly "subscription-bulk-3kg",
          //    then we can do:
          if (data.tags && data.tags.includes('wholesale')) {
            hasWholesale = true;
          }

          // 2) Check if the product is on sale
          if (data.compare_at_price && data.compare_at_price > data.price) {
            productHasSale = true;
            productCompareAtPrice = data.compare_at_price;
            productFinalPrice = data.price;
          } else {
            productHasSale = false;
          }
        },
      });

      // Format prices as before:
      if (productHasSale === true) {
        // slash through old item price
        var itemPrice = '<span class="money was_price">'+Shopify.formatMoney(productCompareAtPrice, $('body').data('money-format'))+'</span><span class="money sale">'+Shopify.formatMoney(productFinalPrice, $('body').data('money-format')) +'</span>';
        cart_items_html += itemPrice+'</strong>';
        
        // Total savings
        saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
        totalSaving = saving + totalSaving;

      } else if (item.price > item.final_price) {
        // slash through the old item price
        var itemPrice = '<span class="money was_price">'+Shopify.formatMoney(item.price, $('body').data('money-format'))+'</span><span class="money sale">'+Shopify.formatMoney(item.final_price, $('body').data('money-format'))+'</span>';
        cart_items_html += itemPrice+'</strong>';

      } else {
        var itemPrice = Shopify.formatMoney(item.price, $('body').data('money-format'));
        cart_items_html += '<span class="money">'+itemPrice+'</span></strong>';
      }

      cart_items_html += '</div></li>';
    });

    var cartDiscounts = cart.cart_level_discount_applications;
    var cartDiscountMessage = "";

    for (i=0; i < cartDiscounts.length; i++) {
      var amount = Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
      var title = cartDiscounts[i].title;
      cartDiscountMessage = '<p class="mm-counter price">' + title + ' (-<span class="money"> ' + amount + '</span>)</p>';
    }

    if (cart.cart_level_discount_applications.length > 0) {
      cart_discounts_html += '<span class="right">' + cartDiscountMessage + '</span><span>Discount</span>'
    }

    cart_action_html += '<span class="right"> <span class="ws--total-saving"><span class="cart_savings sale js-cart_savings nnn"></span></span><span class="money">' + Shopify.formatMoney(cart.items_subtotal_price, $('body').data('money-format')) + '</span></span>' + '<span class="subtotal">Subtotal</span>';

    if(totalSaving > 0 ) {
      cart_savings_html = '(You Saved ' + Shopify.formatMoney(totalSaving, $('body').data('money-format')) + ')';
    } else {
      cart_savings_html = "";
    }
  }

  if(cart.total_price >= shipping_savings) {
    $('.cart_shipping').html('<span class="shipping-title">Shipping</span><span class="shipping_free">Free Shipping</span>');
    $('.discount-content').html("");
  } else {
    $('.cart_shipping').html('<span class="shipping-title">Shipping</span><span class="shipping_free">Free for orders over $45</span>');
    $('.discount-content').html('');
  }
  $('.js-cart_items').html(cart_items_html);
  $('.js-cart_discounts').html(cart_discounts_html);
  $('.js-cart_subtotal').html(cart_action_html);
  $('.js-cart_savings').html(cart_savings_html);

  var $adminBar = $('#admin_bar_iframe'),
      $items = $('.cart-middle'),
      $more = $('.cart-bottom'),
      $additionalCheckoutButtons = $('.additional-checkout-buttons'),
      moreHeight = $more.outerHeight(),
      adminBarHeight = $adminBar.height();

  $items.css('bottom', moreHeight);

  if ($additionalCheckoutButtons.length > 0) {
    window.sideCartInterval = setInterval(function(){
      moreHeight = $more.outerHeight();
      $items.css('bottom', moreHeight);
    }, 2000);
  }

  if($adminBar.length > 0){
    if($adminBar.css('width') != "40px"){
      $more.css('bottom', adminBarHeight);
      $items.css('bottom', moreHeight + adminBarHeight);
    }
  }

  // =========================================
  // ADD OR REMOVE CLASS ON .cart_container
  // =========================================
  if (hasWholesale) {
    $('.cart_container').addClass('wholesaleInCart');
  } else {
    $('.cart_container').removeClass('wholesaleInCart');
  }
}


  $('body').on("change", "#cart_form input.quantity", function() {
    ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('#cart_form'));
  });

  $('body').on("change", ".cart_content input.quantity", function() {
    ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('.cart_content'));
  });

 
    // $(document).on('click', '.product-form__submit', function(e) {
    
    //   e.preventDefault();
    //   var $addToCartForm = $(this).closest('form');
    //   var $addToCartBtn = $addToCartForm.find('.add_to_cart');

    //   $.ajax({
    //     url: '/cart/add.js',
    //     dataType: 'json',
    //     cache: false,
    //     type: 'post',
    //     data: $addToCartForm.serialize(),
    //     beforeSend: function() {
    //       $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
    //       $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
    //     },
    //     success: function(itemData) {
    //       $addToCartBtn.find('.checkmark').addClass('checkmark-active');

    //       window.setTimeout(function(){
    //         $addToCartBtn.removeAttr('disabled').removeClass('disabled');
    //         $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
    //         $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
    //       }, 1000);

          
    //       $.ajax({
    //         url: '/cart.js',
    //         dataType: "json",
    //         cache: false,
    //         success: function(cart) {
    //           setTimeout(function() {
    //             refreshCart(cart);
    //                 // $('.cd-cart-trigger').trigger('click');
    //               //makeSearch();
    //           }, 500)
    //         }
    //       });
    //     },
    //     error: function(XMLHttpRequest) {
    //       var response = eval('(' + XMLHttpRequest.responseText + ')');
    //       response = response.description;
    //       $('.warning').remove();

    //       var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
    //       $addToCartForm.after(warning);
    //       $addToCartBtn.removeAttr('disabled').removeClass('disabled');
    //       $addToCartBtn.find('span').text("You can only add {{ quantity }} of this item to your cart.").removeClass('zoomOut').addClass('zoomIn');
    //     }
    //   });

    //   return false;
    // });
  
  
    $(document).on('click', '.product-form__submit1', function(e) {
    
      e.preventDefault();
      var $addToCartForm = $(this).closest('form');
      var $addToCartBtn = $addToCartForm.find('.add_to_cart');

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
        },
        success: function(itemData) {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');

          window.setTimeout(function(){
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);

          
          $.ajax({
            url: '/cart.js',
            dataType: "json",
            cache: false,
            success: function(cart) {
              setTimeout(function() {
                refreshCart(cart);

//                     $('#header .cd-cart-trigger').trigger('click');
//                                     $('.aa1').trigger('click');

                                                console.log('aaaa')

                  //makeSearch();
              }, 500)
            }
          });
        },
        error: function(XMLHttpRequest) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          $('.warning').remove();

          var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
          $addToCartForm.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text("You can only add {{ quantity }} of this item to your cart.").removeClass('zoomOut').addClass('zoomIn');
        }
      });

      return false;
    });
   function makeSearch(){
                  $("html, body").animate({
                    scrollTop: 0
                  }, 800);

                }
  
 
      var $adminBar = $('#admin_bar_iframe'),
          $items = $('.cart-middle'),
          $more = $('.cart-bottom'),
          $additionalCheckoutButtons = $('.additional-checkout-buttons'),
          moreHeight = $more.outerHeight(),
          adminBarHeight = $adminBar.height();

      $items.css('bottom', moreHeight);

      if ($additionalCheckoutButtons.length > 0) {
        window.sideCartInterval = setInterval(function(){
          moreHeight = $more.outerHeight();
          $items.css('bottom', moreHeight);
        }, 2000);
      }

      if($adminBar.length > 0){
        if($adminBar.css('width') != "40px"){
          $more.css('bottom', adminBarHeight);
          $items.css('bottom', moreHeight + adminBarHeight);
        }
      } 
    
 

});
//Used for cart functionality
function htmlEncode(value){
    if (value) {
        return $('<div/>').text(value).html();
    } else {
        return '';
    }
}
jQuery(document).ready(function($){
  //if you change this breakpoint in the style.css file (or _layout.scss if you use SASS), don't forget to update this value as well
  var $L = 1200,
      $menu_navigation = $('#main-nav'),
      $hamburger_icon = $('#cd-hamburger-menu'),
      $cart_trigger = $('.cd-cart-trigger'),
      $lateral_cart = $('#cd-cart'),
      $shadow_layer = $('#cd-shadow-layer'),
      $closs_pop = $('#close-pop');
  //open lateral menu on mobile
  $hamburger_icon.on('click', function(event){
    event.preventDefault();
    //close cart panel (if it's open)
    $lateral_cart.removeClass('speed-in');
    toggle_panel_visibility($menu_navigation, $shadow_layer, $('body'));
  });
  //open cart
  $cart_trigger.on('click', function(event){
    event.preventDefault();
    //close lateral menu (if it's open)
    
    toggle_panel_visibility($lateral_cart, $shadow_layer, $('body'));
  });

  //close lateral cart or lateral menu
  $shadow_layer.on('click', function(){
    $shadow_layer.removeClass('is-visible');
    // firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
    if( $lateral_cart.hasClass('speed-in') ) {
      $lateral_cart.removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
        $('body').removeClass('overflow-hidden');
      });
    } else {
      $lateral_cart.removeClass('speed-in');
    }
  });
  //close lateral cart or lateral menu
  $closs_pop.on('click', function(){
    $shadow_layer.removeClass('is-visible');
    // firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
    if( $lateral_cart.hasClass('speed-in') ) {
      $lateral_cart.removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
        $('body').removeClass('overflow-hidden');
      });
    } else {
      $lateral_cart.removeClass('speed-in');
    }
  });
});

function toggle_panel_visibility ($lateral_panel, $background_layer, $body) {
  if( $lateral_panel.hasClass('speed-in') ) {
    // firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
    $lateral_panel.removeClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
      $body.removeClass('overflow-hidden');
    });
    $background_layer.removeClass('is-visible');

  } else {
    $lateral_panel.addClass('speed-in');
    $lateral_panel.addClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
      $body.addClass('overflow-hidden');
    });
    $background_layer.addClass('is-visible');
  }
}
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "$";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }
  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};